import cn from 'classnames'
import { theme } from '../../styles/theme'
import RichContent from '../RichContent'
import Section from '../Section'
import { createUseStyles } from '../../helpers/createStyles'

const PolicySlice = ({ data, first }) => {
  const styles = useStyles()
  const { content } = data
  return (
    <Section grid className={cn(styles.section, { first })}>
      <h1 className={styles.title}>{data.title}</h1>
      <RichContent content={content} className={styles.container} />
    </Section>
  )
}

const useStyles = createUseStyles({
  section: {
    paddingBottom: theme.spacingPx(10),
    '&.first': {
      paddingTop: theme.spacingPx(8),
      [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacingPx(18)
      }
    }
  },
  title: {
    gridColumn: '1 / span 8',
    margin: `${theme.spacingPx(6)} 0`,
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      gridColumn: '1 / span 12',
      margin: `${theme.spacingPx(8)} 0`
    }
  },
  container: {
    gridColumn: '1 / span 8',
    [theme.breakpoints.up('md')]: {
      gridColumn: '1 / span 5'
    },
    '& h1': {
      marginBottom: theme.spacingPx(6)
    },
    '& h4': {
      marginTop: theme.spacingPx(10)
    },
    '& ul': {
      padding: '0 0 0 18px',
      margin: '0 0 1.5em'
    },
    '& h5': {
      fontSize: '16px',
      fontWeight: 'bold',
      marginTop: theme.spacingPx(6),
      marginBottom: '1.5em'
    }
  }
})

export default PolicySlice
